export class ClusterError extends Error {
    constructor(msg?: string) {
        super(msg);
        this.name = 'ClusterError';
    }
}
